import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  Tab,
  TextField,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { useEffect, useState } from "react";
import { LoadingButton } from "@mui/lab";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector } from "react-redux";

export default function DownloadExcelDialog({
  open,
  limit,
  onSend,
  onClose,
  loading,
  isSuccess,
  error,
  disabledSend = false,
  options = ["EMAIL"],
  children,
}) {
  const { t } = useTranslation();
  const { profile } = useSelector((state) => state.entities.profile);

  const [email, setEmail] = useState("");
  const [theWayOfGetExcelFile, setTheWayOfGetExcelFile] = useState("EMAIL");
  const [selectedEmail, setSelectedEmail] = useState("MY_EMAIL");

  const closeDialogHandler = () => {
    onClose();
  };

  const onSendHandler = () => {
    if (selectedEmail === "ANOTHER") {
      onSend({ email, selectedEmail });
    } else {
      onSend({ email: profile?.email, selectedEmail });
    }
  };

  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  useEffect(() => {
    if (isSuccess) {
      setShowSuccessMessage(true);
    }
  }, [isSuccess]);

  useEffect(() => {
    if (!open) {
      setEmail("");
      setTheWayOfGetExcelFile("EMAIL");
      setSelectedEmail("MY_EMAIL");
      setShowSuccessMessage(false);
    }
  }, [open]);

  return (
    <>
      <Dialog
        open={open}
        onClose={(e) => e.preventDefault()}
        aria-labelledby="download-excel-title"
        aria-describedby="download-excel-description"
        fullWidth
      >
        <DialogTitle id="download-excel-title">{t("Excel file")}</DialogTitle>
        <IconButton
          onClick={closeDialogHandler}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 10,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <Divider />
        <DialogContent>
          <TabContext value={theWayOfGetExcelFile}>
            {options?.length > 1 && (
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <TabList
                  onChange={(event, value) => setTheWayOfGetExcelFile(value)}
                  aria-label="lab API tabs example"
                >
                  <Tab
                    label={t("Get Excel file through email")}
                    value="EMAIL"
                  />
                  <Tab
                    label={t("Download it direct to your device")}
                    value="LOCALE"
                  />
                </TabList>
              </Box>
            )}
            {options?.includes("EMAIL") && (
              <TabPanel
                value="EMAIL"
                sx={{ p: 0, pt: options?.length > 1 ? 2 : 0 }}
              >
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="female"
                  name="radio-buttons-group"
                  value={selectedEmail}
                  onChange={({ target: { value } }) => setSelectedEmail(value)}
                >
                  <FormControlLabel
                    value="MY_EMAIL"
                    control={<Radio />}
                    label={t("Your Email")}
                  />
                  <FormControlLabel
                    value="ANOTHER"
                    control={<Radio />}
                    label={t("Another Email")}
                  />
                  {selectedEmail === "ANOTHER" && (
                    <TextField
                      value={email}
                      onChange={({ target: { value } }) => setEmail(value)}
                      sx={{ mt: 2 }}
                      size="small"
                      label={t("Email")}
                      variant="outlined"
                    />
                  )}
                  {showSuccessMessage && (
                    <Typography sx={{ mt: 2 }} color="success.main">
                      {t(
                        "An excel file will be sent to your email for download",
                      )}
                    </Typography>
                  )}
                  {!!error && <Typography color="error">{t(error)}</Typography>}
                </RadioGroup>
              </TabPanel>
            )}
            {options?.includes("LOCALE") && (
              <TabPanel value="LOCALE" sx={{ pb: 0 }}>
                {/* <ExportExcel
                                limit={limit}
                                criteria={criteria}
                                disabled={!orders?.length || limit > 3000}
                                columns={columns}
                                status={status}
                                searchNumber={searchNumber}
                            /> */}
                {limit <= 3000 && children}
                {limit > 3000 && (
                  <Typography
                    sx={{ display: "block", textAlign: "center" }}
                    variant="caption"
                    color="warning.main"
                  >
                    {t(
                      "If the orders are more than 3000 orders it can only be downloaded via email.",
                    )}
                  </Typography>
                )}
              </TabPanel>
            )}
          </TabContext>
        </DialogContent>
        <Divider />
        <DialogActions>
          <LoadingButton
            sx={{ textTransform: "none" }}
            loading={loading}
            variant="contained"
            onClick={onSendHandler}
            disabled={disabledSend}
          >
            {t("Send")}
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </>
  );
}
